import { apiFetch } from "@/lib/api/client";
import type { BootstrapResponse } from "@/lib/types/session";

export function getBootstrap(): Promise<BootstrapResponse> {
  return apiFetch<BootstrapResponse>("/bootstrap");
}
